module.exports = __webpack_public_path__ + "static/ARB_PHOTOGRAPHY_2-3849b0731c19e9cc70401e8539ee81f8.jpg";